import React from 'react';

import { lang, remCss } from 'src/helpers';
import { ButtonFooter } from './ButtonFooter';

export class BaseAlert extends React.PureComponent {
  state = {
    loading: false,
    dataForm: {}
  };

  componentDidMount() {
    this.setState({ loading: false, dataForm: {} });
  }

  setLoading = (loading) => this.setState({ loading });

  setDataForm = (dataForm) => this.setState({ dataForm });

  renderFooter = (props) => {
    const { loading, dataForm } = this.state;
    return (
      <ButtonFooter
        {...this.props}
        loading={loading}
        setLoading={this.setLoading}
        dataForm={dataForm}
        setDataForm={this.setDataForm}
        {...props}
      />
    );
  };

  renderBody = () => {
    const { body } = this.props;
    const { dataForm } = this.state;

    const bodyContent =
      body && typeof body === 'function'
        ? body({ ...this.props, dataForm, setDataForm: this.setDataForm })
        : body;

    return bodyContent && <div className='mc-modal-body'>{bodyContent}</div>;
  };

  render() {
    const { title, close = true, closeBtn, maxWidth = 350, noBodyBorder = false } = this.props;

    let t =
      typeof title === 'string' ? <pre className='mc-popup-title'>{lang.t(title)}</pre> : title;
    if (typeof title === 'function') t = title(this.props);

    return (
      <div
        className={'mc-popup-contain mc-alert-manager'}
        style={{
          maxWidth: remCss(maxWidth)
        }}
      >
        {(!!t || close) && (
          <div className={'mc-modal-header' + (noBodyBorder ? ' mc-b-none' : '')}>
            {t}
            {close && closeBtn}
          </div>
        )}
        {this.renderBody()}
        {this.renderFooter()}
      </div>
    );
  }
}
